module.exports = __webpack_public_path__ + "media/application/images/2023/stills_1.1.5-cc457fd642cf40e02c6a8de583fb7ab1.png";